import { message } from 'ant-design-vue';

export default {
  namespaced: true,
  state: {
    // 用户基本信息
    userInfoMap: {},
    // 密码验证
    passwordNum: '',
    // 登录密码修改返回信息
    loginUpdate: {},
    // 邮箱验证码
    emaliNum: '',
    //手机号验证码
    mobildNum: '',
    // 绑定邮箱
    emaliData: '',
  },
  actions: {
    /**
     * 用户基本信息获取
     */
    async userBasicData({ commit }) {
      const userList = JSON.parse(sessionStorage.getItem('user')) || {};
      console.log(this);
      const resData = await this.$http.post('/hzwmj/person/getPersonById', {
        personId: userList.id,
      });
      if (resData.code === 200) {
        const userInfoMap = resData.data;
        commit('save', { userInfoMap });
      } else if (resData.code === 900) {
        message.error(resData.msg);
      } else {
        message.error('系统异常');
      }
    },
    /**
     * 登录密码修改和支付密码。9——登录密码，10-支付密码
     */
    async passwordLoginUpdate({ commit }, data) {
      let resData = {};
      const userList = JSON.parse(sessionStorage.getItem('user')) || {};
      if (data.type === 9) {
        resData = await this.$http.post('/hzwmj/person/updatePersonMassage', {
          personId: userList.id,
          type: data.type,
          oldPassword: data.originalPassword,
          newPasswordOne: data.passOne,
          newPasswordTwo: data.passTow,
        });
      } else {
        resData = await this.$http.post('/hzwmj/person/updatePersonMassage', {
          personId: userList.id,
          type: data.type,
          oldPayPassword: data.originalPassword,
          newPayPasswordOne: data.passOne,
          newPayPasswordTwo: data.passTow,
        });
      }
      if (resData.code === 200) {
        if (resData.data === 'false') {
          message.success('密码修改失败');
        } else {
          message.success(resData.data);
        }
        const loginUpdate = resData.data;
        commit('save', { loginUpdate });
      } else if (resData.code === 900) {
        message.error(resData.msg);
      } else {
        message.error('系统异常');
      }
    },
    /**
     * 邮箱验证码获取
     */
    async sendMail({ commit }, data) {
      const email = data;
      console.log('email', email);
      const resData = await this.$http.post('/hzwmj/mail/sendMail', {
        receiver: email,
      });
      if (resData.code === 200) {
        const emaliNum = resData.data;
        commit('save', { emaliNum });
      } else if (resData.code === 900) {
        message.error(resData.msg);
      } else {
        message.error('系统异常');
      }
    },
    /**
     * 手机号验证码获取
     */
    async sendMessage({ commit }, data) {
      const numMobile = data;
      console.log('email', numMobile);
      const resData = await this.$http.post('/hzwmj/sendsms/sendMessage', {
        receiver: numMobile,
      });
      if (resData.code === 200) {
        const mobildNum = resData.data;
        console.log('=resData===', resData);
        console.log('=mobildNum===', mobildNum);
        commit('save', { mobildNum });
      } else if (resData.code === 900) {
        message.error(resData.msg);
      } else {
        message.error('系统异常');
      }
    },
    /**
     * 修改基本信息
     */
    async updatePersonMassage({ commit }, data) {
      const email = data.personEmail;
      const numMobile = data.numMobile;
      const numBBMobile = data.numBBMobile;
      const numberEm = data.numberEm;
      const userType = data.userType;
      const personLicenseid = data.personLocation;
      // 区域
      let areaOne = '';
      let areaTow = '';
      let areaThree = '';
      if (personLicenseid !== undefined && personLicenseid.length !== 0) {
        areaOne = personLicenseid[0];
        areaTow = personLicenseid[1];
        areaThree = personLicenseid[2];
      }
      let areaList = '';
      // 拼接省市区
      if (areaThree !== undefined && areaThree !== '') {
        areaList = areaOne + '/' + areaTow + '/' + areaThree;
      } else {
        areaList = areaOne + '/' + areaTow;
      }
      console.log('personLicenseid', personLicenseid);
      if (userType === 1) {
        const resData = await this.$http.post(
          '/hzwmj/person/updatePersonMassage',
          {
            personLocation: areaList,
            personAddress: data.personAddress,
            personCompanyname: data.personCompanyname,
            personContactname: data.personContactname,
            personFixedtel: data.personFixedtel,
            personLicenseid: data.personLicenseid,
            personMobilephone: data.personMobilephone,
            personHeadphoto: data.personHeadphoto,
            personLicensephoto: data.personLicensephoto,
            userType: data.userType,
            personId: data.personId,
            type: data.type,
          },
        );
        if (resData.code === 200) {
          const emaliData = resData.data;
          message.success(resData.data);
          commit('save', { emaliData });
        } else if (resData.code === 900) {
          message.error(resData.msg);
        } else {
          message.error('系统异常');
        }
      } else {
        const userList = JSON.parse(sessionStorage.getItem('user')) || {};
        const resData = await this.$http.post(
          '/hzwmj/person/updatePersonMassage',
          {
            personId: userList.id,
            type: 8,
            personEmail: email,
            personMobilephone: numMobile,
            // 手机验证码
            phoneChecking: numBBMobile,
            // 邮箱验证码
            checking: numberEm,
          },
        );
        if (resData.code === 200) {
          const emaliData = resData.data;
          message.success(resData.data);
          commit('save', { emaliData });
        } else if (resData.code === 900) {
          message.error(resData.msg);
        } else {
          message.error('系统异常');
        }
      }
    },
  },
  mutations: {
    /**
     * 保存状态
     * @param state
     * @param payload
     */
    save(state, payload) {
      for (let key of Object.keys(payload)) {
        state[key] = payload[key];
      }
    },
  },
};
